import { defineMessages } from 'react-intl'

const scope = `procurify.platform.integrations.features.list-active-users-with-slack.presenter`

export default defineMessages({
  errorMessage: {
    id: `${scope}.errorMessage`,
    defaultMessage: 'Failed to load users. Please try again.',
  },
})
